import {Link} from 'react-router-dom'
import Header from '../Header'
import './index.css'

const Home = props => {
  const onClickJob = () => {
    const {history} = props
    history.replace('/jobs')
  }
  return (
    <>
      <Header />
      <div className="home-container">
        <div className="home-card-container">
          <h1 className="heading-job">
            Find The Job That
            <br />
            <hr />
            Fits Your Life
          </h1>
          <p className="description">
            Millions of people are searching for jobs, salary,
            <br />
            <hr />
            information, company reviews. Find the job that fits your <br />
            <hr />
            abilities and potential.
          </p>
          <Link to="/jobs">
            <button className="job-button" type="button" onClick={onClickJob}>
              Find Jobs
            </button>
          </Link>
        </div>
      </div>
    </>
  )
}

export default Home
